import React from 'react';
import { FileText, Search, MousePointer } from 'lucide-react';

const EmptyState = () => {
  return (
    <div className="empty-state" style={{ textAlign: 'center' }}>
      <div className="empty-state-icon">
        <FileText />
      </div>
      <h2 className="empty-state-title">
        No Regulation Selected
      </h2>
      <p className="empty-state-text">
        Start by selecting agencies from the sidebar, then choose regulations to view and analyze.
      </p>
      
      <div style={{ marginTop: '32px', textAlign: 'left', maxWidth: '400px', margin: '32px auto 0' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
          <Search size={20} style={{ color: 'var(--accent)', flexShrink: 0, marginTop: '2px' }} />
          <div>
            <p className="text-body" style={{ fontWeight: '500', marginBottom: '4px' }}>Search & Filter</p>
            <p className="text-small">
              Use the agency dropdown and search bar to find specific regulations
            </p>
          </div>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <MousePointer size={20} style={{ color: 'var(--accent)', flexShrink: 0, marginTop: '2px' }} />
          <div>
            <p className="text-body" style={{ fontWeight: '500', marginBottom: '4px' }}>Select & Analyze</p>
            <p className="text-small">
              Click on regulations to view provisions, generate CBA, or consolidate multiple regulations
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;